export default __webpack_public_path__ + "static/media/youduxiaoshuo.3f3b7fa8.png";